<template>
    <v-dialog v-model="getViewFaq" width="55%" height="55%" persistent>
        <v-card>
            <v-card-title>View/Edit Faq </v-card-title>
            <v-divider></v-divider>
            <v-tabs>
                <v-tab>English</v-tab>
                <v-tab>Spanish</v-tab>
                <v-tab-item>
                    <v-row no-gutters class="mx-5 mt-5">
                        <v-col cols="3">
                            <v-text-field label="Link ID" outlined disabled v-model="faqDetails.linkId"
                                class="mx-2"></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field label="Court Location" outlined disabled
                                v-model="faqDetails.courtLocationCode" class="mx-2"></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-select :items="getFaqCategory" item-text="categoryName" item-value="categoryName"
                                v-model="faqDetails.category" label="Category" class="mx-2"></v-select>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mx-5">
                        <v-col cols="4">
                            <v-textarea v-model="faqDetails.question" label="Question" class="ma-2 mr-4"
                                outlined></v-textarea>
                        </v-col>
                        <v-col cols="8">
                            <v-textarea v-model="faqDetails.answer" label="Answer" class="ma-2 ml-4"
                                outlined></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mx-5">
                        <v-col cols="2">
                            <v-switch v-model="faqDetails.showmap" label="Show Map" class="mx-2"></v-switch>
                        </v-col>
                        <v-col cols="4">
                            <v-select :items="getMaps" item-text="mapName" item-value="mapName"
                                v-model="faqDetails.mapName" label="Map Name" outlined
                                :disabled="!faqDetails.showmap"></v-select>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mx-5">
                        <v-col cols="2">
                            <v-switch v-model="faqDetails.showUrl" label="Show QR" class="mx-2"></v-switch>
                        </v-col>
                        <v-col cols="4">
                            <v-textarea v-model="faqDetails.urlDetails" label="QR Code info" outlined
                                :disabled="!faqDetails.showUrl"></v-textarea>
                        </v-col>
                    </v-row>
                    <v-card-actions class="justify-end">
                        <v-btn width="100" class="ma-3" color="primary" @click="editFaq()" :loading="loading"><v-icon class="mr-2"
                                small>mdi-pencil</v-icon>Edit</v-btn>
                        <v-btn width="100" class="ma-3" @click="closeFaq()" color="grey"><v-icon class="mr-2"
                                small>mdi-close</v-icon> Close</v-btn>
                    </v-card-actions>
                </v-tab-item>
                <v-tab-item>
                    <v-row no-gutters class="mx-5 mt-5">
                        <v-col cols="3">
                            <v-text-field label="Link ID" outlined disabled v-model="faqDetailsEs.linkId"
                                class="mx-2"></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field label="Court Location" outlined disabled
                                v-model="faqDetailsEs.courtLocationCode" class="mx-2"></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-select :items="getFaqCategoryEs" item-text="categoryName" item-value="categoryName"
                                v-model="faqDetailsEs.category" label="Category" class="mx-2"></v-select>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mx-5">
                        <v-col cols="4">
                            <v-textarea v-model="faqDetailsEs.question" label="Question" class="ma-2 mr-4"
                                outlined></v-textarea>
                        </v-col>
                        <v-col cols="8">
                            <v-textarea v-model="faqDetailsEs.answer" label="Answer" class="ma-2 ml-4"
                                outlined></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mx-5">
                        <v-col cols="2">
                            <v-switch v-model="faqDetailsEs.showmap" label="Show Map" class="mx-2"></v-switch>
                        </v-col>
                        <v-col cols="4">
                            <v-select :items="getMaps" item-text="mapName" item-value="mapName"
                                v-model="faqDetailsEs.mapName" label="Map Name" outlined
                                :disabled="!faqDetailsEs.showmap"></v-select>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mx-5">
                        <v-col cols="2">
                            <v-switch v-model="faqDetailsEs.showUrl" label="Show QR" class="mx-2"></v-switch>
                        </v-col>
                        <v-col cols="4">
                            <v-textarea v-model="faqDetailsEs.urlDetails" label="QR Code info" outlined
                                :disabled="!faqDetailsEs.showQr"></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="10">
                            <v-alert color="info" class="ma-2 white--text" type="info">Spanish Version will be updated
                                by Advanced Robot Solutions.</v-alert>
                        </v-col>
                        <v-col cols="2" align="center" justify="center">
                            <v-btn width="100" class="ma-3" @click="closeFaq()" color="grey"><v-icon class="mr-2"
                                    small>mdi-close</v-icon> Close</v-btn>
                        </v-col>
                    </v-row>
                </v-tab-item>
            </v-tabs>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    name: "viewFaqs",
    data() {
        return {
            faqDetails: {
                question: '',
                answer: '',
                category: '',
                showmap: false,
                mapName: '',
                showUrl: false,
                urlDetails: '',
                linkId: 0,
                courtLocationCode: '',
            },
            faqDetailsEs: {
                question: '',
                answer: '',
                category: '',
                showmap: false,
                mapName: '',
                showUrl: false,
                urlDetails: '',
                linkId: 0,
                courtLocationCode: '',
            },
            loading: false
        }
    },
    computed: {
        ...mapGetters(['getViewFaq', 'getSelectedFaq', 'getFaqCategory', 'getMaps', 'snackBar', 'getFaqsEs', 'getFaqCategoryEs'])
    },
    watch: {
        getSelectedFaq(newVal) {
            this.getSelectedFaq1(newVal);
        },
        snackBar(newVal) {
            if (newVal.show) {
                this.closeFaq();
            }
        },
    },
    methods: {
        getSelectedFaq1(newVal) {
            this.faqDetails = JSON.parse(JSON.stringify(newVal)); // clone to avoid mutation issues
            if (this.faqDetails.urlDetails !== null) {
                this.faqDetails.urlDetails = JSON.stringify(this.faqDetails.urlDetails, null, 2);
            }
            this.faqDetailsEs = this.getFaqsEs.filter(faq => faq.linkId === this.faqDetails.linkId)[0];
        },
        editFaq() {
            this.loading = true
            this.$store.dispatch('updateIndex', this.faqDetails)
        },
        closeFaq() {
            this.loading = false
            this.faqDetails = {
                question: '',
                answer: '',
                category: '',
                showmap: false,
                mapName: '',
                showUrl: false,
                urlDetails: '',
                linkId: 0
            }
            this.$store.commit('setViewFaq', false);
        },
    },
    mounted() {
        if (this.getFaqsEs.length > 0) {
            this.faqDetails = this.getSelectedFaq
            if (this.faqDetails.urlDetails !== null) {
                this.faqDetails.urlDetails = JSON.stringify(this.faqDetails.urlDetails)
            }
            this.faqDetailsEs = this.getFaqsEs.filter(faq => faq.linkId === this.faqDetails.linkId)[0];
            console.log('FAQ DETAILS in mounted:', this.faqDetails)
        }
    },
}
</script>